import React, { useState, useEffect } from 'react';
import useAptitudeTestResponsesContext from '../../../../../hooks/useAptitudeTestResponsesContent';
import {
  useFinishAptitudeTestMutation,
  useUpdateResponsesAptitudeMutation,
} from '../AptitudeQuizSlice';
import Questions from './questions';

import AptitudeTestCardBar from '../layout/AptitudeTestCardBar';
import { useInterval } from 'hooks/useInterval';
import { useTimeout } from 'hooks/useTimeout';
import { useNavigate } from 'react-router-dom';

const Index: React.FC<{ data: any }> = ({ data }) => {
  const [updateResponsesAptitude] = useUpdateResponsesAptitudeMutation();
  const { state, dispatch } = useAptitudeTestResponsesContext();
  const [timeLeft, setTimeLeft] = useState(data.overallTimeLeft);
  const [finishAptitudeTest, { isLoading }] = useFinishAptitudeTestMutation();

  const navigate = useNavigate();
  const employersAssessmentId = localStorage.getItem(
    'localEmployersAssessmentId'
  );
  function finishTest() {
    finishAptitudeTest({ employersAssessmentId })
      .unwrap()
      .then((res: any) => {
        navigate('/belong-score/aptitude/scorecard');
      });
  }
  //Main timeout
  useTimeout(() => {
    finishTest();
  }, timeLeft * 1000);

  useEffect(() => {
    updateResponsesAptitude({
      responses: state.responses,
      employersAssessmentId,
    });
  }, [state.responses, updateResponsesAptitude, employersAssessmentId]);

  //Main Timer
  useInterval(() => {
    const minutesLeft = Math.floor(timeLeft / 60);
    const secondsLeft = timeLeft % 60;
    dispatch({
      type: 'UPDATE_REMAINING_TIME',
      payload: { minutesLeft, secondsLeft },
    });
    setTimeLeft((timeLeft: number) => timeLeft - 1);
  }, 1000);

  return isLoading ? (
    <p>Loading...</p>
  ) : (
    <div className='px-1 sm:px-4 lg:px-32 py-8 sm:py-16'>
      <AptitudeTestCardBar
        minutes={state.overallTimeLeft.minutes}
        seconds={state.overallTimeLeft.seconds}
      />
      <Questions />
    </div>
  );
};

export default Index;
